import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const ModulePriceForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'module_price'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        { 
            type: 'dropdown', 
            name: 'feature', 
            label: 'billing.module_price.module_name_label', 
            apiRequest: [{
                endpoint: 'get_total_feature_list',
                object: 'total_feature',
                params: { },
                useCache: true
            }],
            disabled_selected: 'forms.select_type_disabled_selected',
            optionFormat: 'feature_translation',
            selectionFormat: 'feature_translation',
            allowNoneOption: false,
            showSearch: false,
        },
        {
            name: 'description',
            label: 'billing.module_price.description_label',
            type: 'textarea',
            rows: 3,
            placeholder: 'billing.module_price.description_placeholder',
        },
        {
            name: 'image',
            label: 'billing.module_price.image_label',
            type: 'image',
            alignment: 'stacked',
            imageType: 'landscape',
            dropzoneText: 'billing.module_price.image_placeholder',
            apiField: {
                fileUpload: 'image_file',
                fileName: 'image_filename',
                imageDeleted: 'image_deleted'
            },
        },
        {
            type: 'dropdown',
            name: 'price_type',
            label: 'billing.module_price.price_type_label', 
            disabled_selected: 'forms.select_type_disabled_selected',
            hardcodedOptions: [
                { value: 'per_unit', name: 'billing.module_price.per_unit_label'},
                { value: 'per_seat', name: 'billing.module_price.per_seat_label'},
            ],
            allowNoneOption: false,
            showSearch: false,
        },
        { 
            type: 'price', 
            name: 'flat_price', 
            label: 'billing.module_price.price_label', 
            apiObject: 'currency',
            dependentOn: { fieldName: 'price_type', value: 'per_unit' },
        },
        { 
            type: 'price', 
            name: 'price_per_seat', 
            label: 'billing.module_price.per_seat_price', 
            apiObject: 'currency',
            dependentOn: { fieldName: 'price_type', value: 'per_seat' },
        },
        {
            type: 'header',
            header: 'billing.module_price.threshold_header',
            description: 'billing.module_price.threshold_description',
            dependentOn: { fieldName: 'price_type', value: 'per_seat' },
        },
        {
            name: 'enable_threshold',
            label: 'billing.module_price.enable_threshold_label',
            type: 'checkbox',
            dependentOn: { fieldName: 'price_type', value: 'per_seat' },
        },
        { 
            type: 'number', 
            name: 'threshold', 
            label: 'billing.module_price.threshold_label', 
            dependentOn: { fieldName: 'enable_threshold', value: true },
            width: '50%',
            group: 'field-row-1',
        },
        {
            type: 'price',
            name: 'price_above_threshold',
            label: 'billing.module_price.price_above_threshold_label',
            apiObject: 'currency',
            dependentOn: { fieldName: 'enable_threshold', value: true },
            width: '50%',
            group: 'field-row-1',
        },
        {
            type: 'header',
            header: 'billing.module_price.highlight_header',
            description: 'billing.module_price.highlight_description',
        },
        {
            name: 'is_highlighted',
            label: 'billing.module_price.highlight_label',
            type: 'checkbox',
        },
    ];

    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default ModulePriceForm;